// extracted by mini-css-extract-plugin
export default {"root":"GojslmRDwOQC04n9wdog","wrap":"yhn6jtdi43ntCgSYJcvW","main":"dDkdTfliOdUzx1BkYUnq","header":"mQnZ65MW0jwAd1Quc3uH","input":"vi5tWzGu8_5dlc1e6BRp"};